<div class="visually-hidden-focusable w-auto text-center"><a tabindex="0" [href]="skipLinkPath">Skip to Main Content</a></div>
<div class="d-flex position-relative">
  <ness-left-navigation id="left-nav" class="collapse active bg-primary-md px-0 d-print-none" (mouseenter)="showNav($event)" (mouseleave)="hideNav($event)"></ness-left-navigation>
  <div class="container-fluid">
    <div class="row">
      <p-messages key="defaultMsg" [closable]="true"></p-messages>
      <div id="main" tabindex="-1" class="col" style="width: calc(100vw - 180px); padding-left: 15px; padding-right: 15px;">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<p-dialog [(visible)]="globalMsgDialog" header="There is an issue contacting the NESS server." [modal]="true" styleClass="dialog-warning" [attr.tabindex]="-1" [attr.role]="'dialog'" [breakpoints]="{'992px': '75vw', '576px': '90vw'}">
  <p>Your system appears to be disconnected from the internet. Please check your internet connection and try your request again.</p>
  <p-footer>
    <button type="button" class="btn btn-secondary" (click)="globalMsgDialog=false">Ok</button>
  </p-footer>
</p-dialog>
